/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeliveryZonesCollectionResponse } from '../../models/delivery-zones-collection-response';

export interface DeliveryZonesGetAll$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;

/**
 * Query parameter for filtering by deliveryZone number.
 */
  number?: number;

/**
 * Query parameter for filtering by deliveryZone type.
 */
  type?: 'Primary' | 'Secondary';

/**
 * Query parameter for filtering by  enable/disabled deliveryZones.
 */
  enabled?: boolean;
  sortDir?: 'ASC' | 'DESC';
  start?: string;
  size?: number;
}

export function deliveryZonesGetAll(http: HttpClient, rootUrl: string, params: DeliveryZonesGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryZonesCollectionResponse>> {
  const rb = new RequestBuilder(rootUrl, deliveryZonesGetAll.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.query('number', params.number, {});
    rb.query('type', params.type, {});
    rb.query('enabled', params.enabled, {});
    rb.query('sortDir', params.sortDir, {});
    rb.query('start', params.start, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeliveryZonesCollectionResponse>;
    })
  );
}

deliveryZonesGetAll.PATH = '/stores/{storeId}/delivery-zones';
